import { INIT_EDIT_QUOTE } from 'store/quotes/types';

import { types } from './actions';

const initialState = {
  isFetchingRevisions: false,
  isQuoteRevisionDrawerOpen: false,
  relatedRevisions: [],
};

const reducer = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case INIT_EDIT_QUOTE:
      return { ...initialState };
    case types.OPEN_REVISION_DRAWER:
      return {
        ...state,
        isQuoteRevisionDrawerOpen: true,
      };
    case types.CLOSE_REVISION_DRAWER:
      return {
        ...state,
        isQuoteRevisionDrawerOpen: false,
      };
    case types.GET_RELATED_REVISIONS_REQUEST:
      return {
        ...state,
        isFetchingRevisions: true,
      };
    case types.GET_RELATED_REVISIONS_SUCCESS:
      return {
        ...state,
        isFetchingRevisions: false,
        relatedRevisions: payload.relatedRevisions,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.quotes.quoteRevisionDrawer;

export const getIsFetchingRevisions = (state) =>
  getScope(state).isFetchingRevisions;

export const getIsQuoteRevisionDrawerOpen = (state) =>
  getScope(state).isQuoteRevisionDrawerOpen;

export const getRelatedRevisions = (state) => getScope(state).relatedRevisions;
